<template>
	<div class="row"></div>
</template>
<script>
export default {
	name: "Edit",

	data() {
		return {};
	},
	mounted() {},
	methods: {},
};
</script>
<style >
.router-link-exact-active {
	cursor: pointer;
}
</style>
